import classNames from 'classnames/bind';
import { noop, range } from 'lodash';
import { ReactElement, useEffect, useState } from 'react';
import styles from './PageControl.module.scss';

const cx = classNames.bind(styles);

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function PageControl({ count = 3, active = 0, onSelect = noop }): ReactElement {
  const [activePage, setActivePage] = useState(active);

  useEffect(() => {
    setActivePage(active);
  }, [active]);

  const handlePageClick = (index) => {
    onSelect(index);
  };

  return (
    <div className={cx('body')}>
      {range(count).map((item, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className={cx('page', { active: index === activePage })} onClick={() => handlePageClick(index)} key={index} />
      ))}
    </div>
  );
}

export default PageControl;
